import React from "react";
import { Box, Grid } from "@mui/material";
import { AdapterIcon } from "../../../../../../../../generic/icon/component-icon/component-icon";
import { styles } from "../create-app-page-adapters-list.styles";
// @ts-ignore
import { StriimTypography, StriimTooltip } from "@striim/striim-ui-v2";
import licenseService from "../../../../../../../../../core/services/metaStoreService/license-service";
import { CreateAppPageAdapterData } from "../../../../create-app-page-utils";
import { useInView } from "react-intersection-observer";

interface AdapterItemProps {
    adapter: CreateAppPageAdapterData;
    handleSelection: Function;
    type: String;
    selectedView: "list" | "grid";
    filters: {
        id: string;
        category: string;
    };
    initialInView: boolean;
    scrollableRef: React.RefObject<HTMLDivElement>;
    recentlyUsedAdapterView: boolean;
}

const AdapterItem: React.FC<AdapterItemProps> = ({
    adapter,
    handleSelection,
    type,
    selectedView,
    filters,
    initialInView,
    scrollableRef,
    recentlyUsedAdapterView
}) => {
    const { ref: visibleRef, inView } = useInView({
        root: scrollableRef?.current,
        initialInView: initialInView,
        rootMargin: "120px", // Prerender when scroll is close to this component
        fallbackInView: true
    });

    return (
        <div ref={visibleRef} style={{ height: selectedView === "grid" ? "54px" : "45px" }}>
            {inView ? (
                <StriimTooltip
                    title={
                        adapter.isEnabled
                            ? null
                            : (adapter.adapter === "DeltaLakeWriter" ||
                                  adapter.adapter === "FabricDataWarehouseWriter") &&
                              licenseService.isLiteLicense
                            ? "Requires Standard Plan. Go to Azure Marketplace to upgrade."
                            : adapter.adapter?.toLowerCase() === "msjet"
                            ? "Wizards are currently not supported for MSJet. You must use the flow designer to build a pipeline that uses MSJet to read from SQL Server"
                            : "Enabling the selected adapter requires additional license, please contact support@striim.com."
                    }
                    arrow
                    placement="bottom"
                    slotProps={{
                        tooltip: {
                            sx: {
                                fontFamily: "Inter"
                            }
                        }
                    }}
                >
                    <Grid
                        container
                        flexDirection={"row"}
                        sx={styles.itemContainer}
                        style={adapter.isEnabled ? { opacity: 1 } : { opacity: 0.3, cursor: "not-allowed" }}
                        onClick={adapter.isEnabled ? () => handleSelection(adapter) : null}
                        data-test-id={
                            recentlyUsedAdapterView ? `recently-used-adapter-${adapter.id}` : `adapter-${adapter.id}`
                        }
                        key={adapter.id}
                    >
                        <AdapterIcon
                            spriteId={adapter.spriteId}
                            newlyReleased={
                                adapter.newlyReleased && filters.category !== "new" && !recentlyUsedAdapterView
                            }
                            isPreviewAdapter={
                                adapter.isPreviewAdapter && filters.category !== "preview" && !recentlyUsedAdapterView
                            }
                            useNative
                            name={adapter.icon}
                            type={type}
                            size={selectedView === "list" ? 45 : 56}
                            showBorder={selectedView !== "list"}
                            adapter={adapter.adapter}
                        />
                        <Box sx={styles.itemText}>
                            <StriimTypography
                                variant="caption3"
                                color={selectedView === "list" ? "primary.900" : "primary.600"}
                            >
                                {adapter.id}
                            </StriimTypography>
                        </Box>
                    </Grid>
                </StriimTooltip>
            ) : null}
        </div>
    );
};

export default AdapterItem;
